import React from "react";
import { Link } from "react-router-dom";
import { Upload, Sparkles, Download } from "lucide-react";

const MAP = { provider_profiles: "providers", services: "services", deals: "deals" };

export default function DataCenterShortcuts({ entity }) {
  const e = MAP[entity];
  if (!e) return null;
  const cls = "inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium hover:border-[#165a71]/40";
  return (
    <>
      <Link to={`/admin/data-center/import?entity=${e}`} className={cls} data-testid={`shortcut-import-${e}`}><Upload className="h-4 w-4" /> Import</Link>
      <Link to={`/admin/data-center/ai-import`} className={cls} data-testid={`shortcut-ai-import-${e}`}><Sparkles className="h-4 w-4" /> AI Import</Link>
      <Link to={`/admin/data-center/export?entity=${e}`} className={cls} data-testid={`shortcut-export-${e}`}><Download className="h-4 w-4" /> Export</Link>
    </>
  );
}
